import { OptionType, Select } from '@components/Select';
import { TaskAttributes } from 'chaika-test-attributes';
import { translate } from '@chaika/i18n/helper';

interface Props {
    options: OptionType<string>[];
    typeId?: string;
    dataTest?: string;
    disabled?: boolean;
    onSelect(option: OptionType<string>, name: string): void;
}

export function TaskTypeSelect({ options, typeId, onSelect, dataTest, disabled }: Props): React.ReactElement<any> {
    const tChoseFromList = translate('chooseFromList');
    const tWhatNeedsToBeDone = translate('whatNeedsToBeDone');

    return (
        <Select
            forcePlaceholder
            options={options}
            disabled={disabled}
            selectedValue={typeId}
            placeholder={tChoseFromList}
            title={tWhatNeedsToBeDone}
            name={'type'}
            onChange={onSelect}
            dataTest={dataTest ?? TaskAttributes.Type}
        />
    );
}
